import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0be7e29c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "document bg-white relative overflow-y-scroll" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header w-full text-right fixed relative" }, null, -1))
const _hoisted_3 = { class: "body" }
const _hoisted_4 = { class: "title-section-spacing" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<h1 class=\"font-bold block text-left\" data-v-0be7e29c>Titolo Documento</h1><h3 class=\"font-bold grey-text text-left subtitle\" data-v-0be7e29c> Sottotitolo Comunicazione</h3><div class=\"block date\" data-v-0be7e29c>Data inserimento: gg/mm/anno</div><div class=\"content\" data-v-0be7e29c></div><div class=\"options\" data-v-0be7e29c></div>", 5)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SecondaryButton = _resolveComponent("SecondaryButton")!
  const _component_RelatedDocumentsSection = _resolveComponent("RelatedDocumentsSection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_SecondaryButton, {
          class: "edit-document text-primary block float-right",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showEditDocumentDialog()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Modifica comunicazione")
          ]),
          _: 1
        }),
        _hoisted_5,
        _createVNode(_component_RelatedDocumentsSection)
      ])
    ])
  ]))
}